import { useEffect, useState } from 'react';
import { Circles } from 'react-loading-icons';
import { getRecentGames } from '../../../util/apis/GameAPI';
import { fetchGames } from '../../../util/apis/Ourapi';
import Button from '../../Button';

export default function PlayTab() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchGames();

        const isGamesValid =
          Array.isArray(data?.result) && data.result.length > 0;

        if (isGamesValid) {
          setContent(data.result.slice(0, 12));
        } else {
          const fallbackData = await getRecentGames.get(true);
          setContent(fallbackData.results.slice(0, 12));
        }
      } catch (error) {
        console.error('Error occurred in fetchGames, trying fallback:', error);

        try {
          const fallbackData = await getRecentGames.get(true);
          setContent(fallbackData.results.slice(0, 12));
        } catch (fallbackError) {
          console.error('Error occurred in getRecentGames too:', fallbackError);
        }
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {content.length > 0 ? (
        <>
          <div
            className="grid place-items-center lg:grid-cols-3 md:grid-cols-3 
          sm:grid-cols-2 grid-cols-2 gap-y-2 gap-x-3 lg:gap-x-12 px-3 md:px-20 lg:px-28 2xl:grid-cols-3"
          >
            {content.map((item, id) => (
              <a
                key={id}
                href={`/rate/game/${item.id}`}
                className="relative mb-2 md:w-72 lg:w-96 rounded-xl overflow-hidden group"
              >
                <div className="relative">
                  <img
                    src={item.background_image}
                    className="w-full rounded-xl border-2 aspect-backdrop group-hover:scale-105 transition-transform duration-300"
                    loading="eager"
                  />
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition duration-300 rounded-xl"></div>
                  <div className="absolute bottom-0 w-full text-white bg-black/10 px-3 py-2 text-center text-sm font-semibold group-hover:bg-black/80 transition duration-300">
                    {item.name}
                  </div>
                </div>
              </a>
            ))}
          </div>

          <div className="flex justify-center py-5">
            <Button variant="button" type="button" disabled>
              Find More (Coming Soon)
            </Button>
          </div>
        </>
      ) : (
        <div className="flex justify-center items-center h-40">
          <Circles className="text-white" />
        </div>
      )}
    </>
  );
}
